import { Component, Input } from '@angular/core';
import { Service } from '@spaq/utils/service-model';
import { getServiceCost, getServiceEndAt, getServiceStartAt } from '@spaq/utils';

@Component({
	selector: 'spaq-service-detail-debug',
	template: `
		<div class="col-md-12">
			<div class="alert alert-danger row">
				<div class="col-md-4">ID de service</div>
				<div class="col-md-8">{{ service.availableServiceId }}</div>
				<div class="col-md-4">ID du stationnement</div>
				<div class="col-md-8">{{ service.parkIdentificationNo }}</div>
				<div class="col-md-4">Début abonnement</div>
				<div class="col-md-8">{{ startAt | moment }}</div>
				<div class="col-md-4">Se termine le</div>
				<div class="col-md-8">{{ endAt | moment }}</div>
				<div class="col-md-4">Coûts</div>
				<div class="col-md-8">{{ cost }}</div>
				<div class="col-md-4">Indice facturation</div>
				<div class="col-md-8">
					{{ service.partialPrice }} ({{ service.startDateFormatted }} - {{ service.partialInvoiceToDateFormatter }})
				</div>
				<div class="col-md-4">Type de service</div>
				<div class="col-md-8">{{ service.serviceType }}</div>
				<div class="col-md-4">Duration fixe</div>
				<div class="col-md-8">{{ service.isFixedDuration }}</div>
				<div class="col-md-4">Règle démarrage</div>
				<div class="col-md-8">{{ service.serviceStartRule }}</div>
				<div class="col-md-4">Facturation</div>
				<div class="col-md-8">{{ service.serviceBillingType }}</div>
				<div class="col-md-4">Calcul</div>
				<div class="col-md-8">{{ service.partialMonthCalculation }}</div>
				<div class="col-md-4">Durée</div>
				<div class="col-md-8">{{ service.durationTime }}</div>
				<div class="col-md-4">Peu être annulé</div>
				<div class="col-md-8">{{ service.isCancelable }}</div>
				<div class="col-md-4">Règle d'annulation</div>
				<div class="col-md-8">{{ service.cancelationRule }}</div>
				<div class="col-md-4">En vente à partir</div>
				<div class="col-md-8">{{ service.availableFromFormated }}</div>
				<div class="col-md-4">En vente jusqu'à</div>
				<div class="col-md-8">{{ service.availableUntilFormated }}</div>
				<div class="col-md-4">Début de l'abonnement</div>
				<div class="col-md-8">{{ service.onSaleFromFormated }}</div>
				<div class="col-md-4">Fin de l'abonnement</div>
				<div class="col-md-8">{{ service.onSaleUntilFormated }}</div>
			</div>
		</div>
	`
})
export class ServiceDetailDebugComponent {
	get cost() {
		return getServiceCost(this.service.rawData, this.startAt, this.endAt);
	}

	get endAt() {
		return getServiceEndAt(this.service.rawData);
	}

	get startAt() {
		return getServiceStartAt(this.service.rawData);
	}

	@Input() service: Service;

	constructor() {}
}
